import styled from 'styled-components/macro';
import ReactSelect, { IOption } from 'src/components/ui-kit/ReactSelect';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { PrimaryColors } from 'src/types/globalTypes';

const Wrapper = styled.div`
  display: grid;
  justify-items: center;
  line-height: 40px;
  text-align: left;
  padding: 1em;
`;

interface Iprops {
  options: IOption[];
  colorType?: PrimaryColors;
}

/**
 * 操作說明行動版選項列表
 */
const DirectionMobileList: React.FC<Iprops> = ({ options, colorType }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [href, setHref] = useState<string | number>('');

  useEffect(() => {
    const handleOnChange = () => {
      typeof href === 'string' && navigate(href);
    };
    handleOnChange();
  }, [href, navigate]);

  return (
    <Wrapper>
      <ReactSelect
        onChange={setHref}
        options={options}
        customizedTitle={'標題'}
        width={'90%'}
        defaultValue={pathname}
        isBigForm
        primaryColors={colorType}
      />
    </Wrapper>
  );
};

export default DirectionMobileList;
